import * as yup from 'yup';

const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];
const ACCOUNT_TYPE_CHOICES = ['Cash', 'Bank', 'Credit Card', 'Other'];

export const moneyAccountValidationSchema = yup.object({
  name: yup.string().trim().required('Account name is required').min(2, 'Account name must be at least 2 characters'),
  account_type: yup.string().required('Account type is required').oneOf(ACCOUNT_TYPE_CHOICES, 'Invalid account type selected'),
  currency: yup.string().required('Currency is required').oneOf(CURRENCY_CHOICES, 'Invalid currency selected'),
  remarks: yup.string().trim().max(500, 'Remarks must be less than 500 characters'),
  is_active: yup.boolean(),
});